/** @format */

import React from 'react';
import Translate from '@components/translation/translate-text-wrapper';
import type { RefinementListProps } from 'react-instantsearch';
import { DynamicWidgets, useRefinementList } from 'react-instantsearch';
import Panel from '@components/search/search-components/panel';
import { useSafeTranslate } from '@hooks/use-safe-translate';

/**
 * Update Filter Names.
 *
 * @param items
 * @returns
 */
const updateFilterNames: RefinementListProps['transformItems'] = (items) => {
  return items.map((item) => {
    const { label } = item;
    let labelName = label;
    let order;

    switch (label) {
      case 'blade-page':
        labelName = 'Pages';
        order = 1;
        break;
      case 'blog':
        labelName = 'Blogs';
        order = 2;
        break;
      case 'course':
        labelName = 'Courses';
        order = 3;
        break;
      case 'event':
        labelName = 'Events';
        order = 5;
        break;
      case 'news':
        labelName = 'Press Releases';
        order = 6;
        break;
      case 'product':
        labelName = 'Products';
        order = 0;
        break;
      case 'cme-credit':
        labelName = 'CME Credit';
        order = 7;
        break;
    }

    return {
      ...item,
      label: labelName,
      order: order,
    };
  });
};

/**
 * Facets List.
 */
const FacetsList = (props): JSX.Element => {
  const { items, refine } = useRefinementList(props);
  const updatedItems = updateFilterNames(items);

  /**
   * Render.
   */
  if (updatedItems?.length > 0) {
    updatedItems.sort((a, b) => (a.order > b.order ? 1 : -1));
    return (
      <ul>
        {updatedItems.map((filter) => {
          const { label, value, count } = filter;

          if (label.toLowerCase() !== 'events') {
            return (
              <li className={value} key={label}>
                <input
                  className="ais-RefinementList-checkbox"
                  type="checkbox"
                  value={value}
                  onChange={() => {
                    refine(value);
                  }}
                />
                <label>
                  <span className="labelText">
                    <Translate>{label}</Translate>
                  </span>
                  <span className="count">({count})</span>
                </label>
              </li>
            );
          }
        })}
      </ul>
    );
  }

  return <></>;
};

/**
 * Search Filters.
 */
const SearchFacets = (): JSX.Element => {
  const filterText = useSafeTranslate('Filters', true);

  /**
   * Render.
   */
  return (
    <DynamicWidgets>
      <Panel header={filterText}>
        <FacetsList attribute="pageType" />
      </Panel>
    </DynamicWidgets>
  );
};
export default SearchFacets;
